import axios from "axios";

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const ContractHostel = {
    async create(data_contract) {
        get_token();
        try {
            return await axios.post(
                '/statement_hostel/pichers/contract_hostel',
                { data_contract }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async update(data_contract) {
        get_token();
        try {
            return await axios.put(
                '/statement_hostel/pichers/contract_hostel/:id',
                { data_contract }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    }
}

export default ContractHostel;